import { GetActiveViewCallback, TabConfig } from '@cas/components/tabs/tabs/useTabs';
import { Fragment } from 'react';

/**
 * Override the default behaviour of the getActiveView callback in the useTabs hook.
 * Ensure that all tabs are mounted even if they are not displayed.
 */
export const getFormTabActiveView: GetActiveViewCallback = (tabConfigs, activeTab) => {
  // First check if a valid activeTab exists.
  if (typeof activeTab !== 'undefined' && activeTab < tabConfigs.length) {
    return (
      <>
        {tabConfigs.map(({ view }: TabConfig, i: number) => {
          if (activeTab === i) {
            // Return the active view unaltered.
            return <Fragment key={i}>{view}</Fragment>;
          } else {
            /**
             * Return all other views wrapped in a non-displayed div.
             * Using 'display: none' allows HTML to be included without affecting layout.
             * This approach ensures that the whole form (split across several tabs) is always available for state management.
             */
            return (
              <div style={{ display: 'none' }} key={i}>
                {view}
              </div>
            );
          }
        })}
      </>
    );
  }

  return null;
};
